import { render } from "./PrimaryModal.vue?vue&type=template&id=73384c19&scoped=true&ts=true"
import script from "./PrimaryModal.vue?vue&type=script&lang=ts"
export * from "./PrimaryModal.vue?vue&type=script&lang=ts"

import "./PrimaryModal.vue?vue&type=style&index=0&id=73384c19&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73384c19"]])

export default __exports__